import { GetAiPrompts } from 'domain/usecases/ai/get-ai-prompts';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAiPrompts extends BaseHttpService<GetAiPrompts.Model> implements GetAiPrompts {
  async getAiPrompts(params: GetAiPrompts.Params): Promise<GetAiPrompts.Model> {
    return await this.request('get', {}, params);
  }
}
